<template>
    <div v-loading.fullscreen.lock="loading">
        <client-search-bar-component
            add_auth="新增客户"
            @search="get_client_index"
            @addTeam="addTeam"
        ></client-search-bar-component>
        <common-table-component
            details_auth="客户详情"
            :col_arr="fcol_arr"
            :table_data="ftable_data"
            @details_row="details_client"
        ></common-table-component>
        <common-page-component
            :current_page="cond.page"
            :page_size="cond.limit"
            :total="ftotal"
            @search="get_client_index"
        ></common-page-component>
        <client-edit-component
            edit_auth="修改客户"
            del_auth="删除客户"
            :id="fid"
            :show_type="edit_type"
            :dialogFormVisible="fdialogFormVisible"
            :client_details_data="fclient_details_data"
            :AllEnterprise="AllEnterprise"
            @exitClientDialog="dialogExit"
            @search="get_client_index"
            @show_edit="show_edit"
            @details_row="details_client"
        ></client-edit-component>
    </div>
</template>

<script>
import { client_index_request,client_details_request } from '@/network/business/client.js'
import { client_list_request } from '@/network/list.js'

import ClientSearchBarComponent from '@/components/business/client/ClientSearchBarComponent'
import CommonTableComponent from '@/components/common/CommonTableComponent'
import CommonPageComponent from '@/components/common/CommonPageComponent'
import ClientEditComponent from '@/components/business/client/ClientEditComponent'

export default {
    name: 'ClientView',
    data() {
        return {
            fid: 0,
            edit_type: 0,
            fdialogFormVisible: false,
            loading: true,
            ftotal: 0,
            cond: {
                name: '',
                type: '',
                status: '',
                page: 1,
                limit: 10,
            },
            ftable_data: [],
            fcol_arr: [
                {
                    prop: 'name',
                    label: '企业名称',
                    minWidth: '280px',
                },{
                    prop: 'type_name',
                    label: '企业类型',
                    minWidth: '100px',
                },{
                    prop: 'status',
                    label: '合作状态',
                    minWidth: '100px',
                    tag: (d) => {
                        if(d===0) {
                            return {
                                type: 'danger',
                                filter_data: '禁用'
                            }
                        } else if(d===1) {
                            return {
                                type: 'warning',
                                filter_data: '临时'
                            }
                        } else if(d===2) {
                            return {
                                type: 'primary',
                                filter_data: '长期'
                            }
                        } else if(d===3) {
                            return {
                                type: 'info',
                                filter_data: '备用'
                            }
                        }
                    }
                },{
                    prop: 'with_zhwl_enterprise',
                    label: '所属我方企业',
                    minWidth: '280px',
                },{
                    prop: 'contacts',
                    label: '联系人',
                    minWidth: '100px',
                },{
                    prop: 'phone',
                    label: '联系电话',
                    minWidth: '120px',
                }
            ],
            fclient_details_data: {},
            AllEnterprise: []
        }
    },
    computed: {},
    methods: {
        addTeam() {
            this.edit_type = 1
            this.fdialogFormVisible = true
        },
        show_edit() {
            this.edit_type = 2
        },
        get_client_index(param = {}) {
            this.loading = true
            this.cond.name = param.name ?? this.cond.name
            this.cond.type = param.type ?? this.cond.type
            this.cond.status = param.status ?? this.cond.status
            this.cond.contacts = param.contacts ?? this.cond.contacts
            this.cond.page = param.page ?? this.cond.page
            if (param.limit) {
                this.cond.limit = param.limit
                this.cond.page = 1
            }

            client_index_request(this.cond)
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.ftable_data = s.result.data
                        this.ftotal = s.result.total
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
        },
        details_client(id) {
            this.fid = id
            this.fdialogFormVisible = true
            client_details_request(id)
                .then((s) => {
                    if (s.status === 0) {
                        this.fclient_details_data = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        dialogExit() {
            this.fdialogFormVisible = false
            this.fid = 0
            this.edit_type = 0
        },
        get_all_enterprise() {
            client_list_request({type: 2})
                .then((s) => {
                    if (s.status === 0) {
                        this.AllEnterprise = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.$message.error(err)
                })
        }
    },
    filters: {},
    props: {},
    created() {
        this.get_client_index()
        this.get_all_enterprise()
    },
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        ClientSearchBarComponent,
        CommonTableComponent,
        CommonPageComponent,
        ClientEditComponent,
    },
    watch: {},
}
</script>

<style lang='less'></style>